import React from 'react'
import { Check } from 'lucide-react'
import { cn } from '@/utils/index'

// Styled components that match MenubarItem appearance but work without Menubar context
/* eslint-disable react/prop-types -- props fully typed on forwardRef generic (no runtime PropTypes) */
export const StyledMenuItem = React.forwardRef<
  HTMLDivElement,
  React.HTMLAttributes<HTMLDivElement> & {
    inset?: boolean
    disabled?: boolean
  }
>(({ className, inset, disabled, onClick, ...props }, ref) => (
  <div
    ref={ref}
    role="menuitem"
    aria-disabled={disabled || undefined}
    className={cn(
      'flex items-center px-2 py-1.5 text-sm font-normal leading-[20px]',
      disabled ? 'opacity-50 cursor-not-allowed' : 'hover:bg-accent/50 cursor-pointer',
      inset && 'pl-8',
      className
    )}
    {...props}
    onClick={disabled ? undefined : onClick}
  />
))
/* eslint-enable react/prop-types */

StyledMenuItem.displayName = 'StyledMenuItem'

export const StyledCheckboxItem = React.forwardRef<
  HTMLDivElement,
  React.HTMLAttributes<HTMLDivElement> & {
    checked?: boolean
    disabled?: boolean
    onClick?: React.MouseEventHandler<HTMLDivElement>
  }
>(({ className, checked, disabled, children, onClick, ...props }, ref) => (
  <div
    ref={ref}
    className={cn(
      'relative flex items-center py-1.5 pl-8 pr-2 text-sm font-normal leading-[20px]',
      disabled ? 'opacity-50 cursor-not-allowed' : 'hover:bg-accent/50 cursor-pointer',
      className
    )}
    {...props}
    onClick={disabled ? undefined : onClick}
  >
    <span className="absolute left-2 flex h-3.5 w-3.5 items-center justify-center">
      {checked && <Check className="h-4 w-4" />}
    </span>
    {children}
  </div>
))

StyledCheckboxItem.displayName = 'StyledCheckboxItem'

export const StyledSeparator = React.forwardRef<
  HTMLDivElement,
  React.HTMLAttributes<HTMLDivElement>
>(({ className, ...props }, ref) => (
  <div ref={ref} className={cn('my-1 h-px bg-muted', className)} {...props} />
))

StyledSeparator.displayName = 'StyledSeparator'
